import { solutionContent } from "@/app/content/landingContent";

export function SolutionSection() {
  return (
    <section
      id="solution"
      className="py-24 md:py-32 px-6 bg-white"
      aria-labelledby="solution-heading"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 max-w-3xl">
          <h2
            id="solution-heading"
            className="text-[clamp(1.875rem,4vw,3rem)] text-slate-900 mb-6 tracking-tight font-bold"
          >
            {solutionContent.heading}
          </h2>
          <p className="text-[clamp(1.125rem,2vw,1.25rem)] text-slate-600 leading-relaxed max-w-prose">
            {solutionContent.description}
          </p>
        </div>

        <ol className="space-y-10 md:space-y-14" aria-label="Etapy współpracy">
          {solutionContent.items.map((item, index) => (
            <li
              key={item.id}
              className="grid grid-cols-1 md:grid-cols-[110px_1fr] gap-2 md:gap-14 items-start"
            >
              {/* Large muted step number — purely decorative */}
              <div
                className="text-[5rem] md:text-[6.5rem] leading-none font-black text-slate-100 select-none md:text-right pt-1"
                aria-hidden="true"
              >
                {index + 1}
              </div>

              {/* Content with left accent border */}
              <div className="border-l-2 border-[#004f4f] pl-6 md:pl-8 py-1">
                <h3 className="text-xl md:text-2xl text-slate-900 mb-3 font-bold leading-snug">
                  {item.title}
                </h3>
                <p className="text-slate-600 leading-relaxed text-base md:text-lg max-w-prose">
                  {item.description}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
